module.exports = __webpack_public_path__ + "img/om.7332c94.svg";